/* eslint-disable react/no-unescaped-entities */
import { PageHero } from '../components/SectionHeading';
import { ScrollReveal } from '../components/Motion';
import { ASSETS, MILESTONES, pick } from '../data/content';
import { useLang } from '../i18n/LanguageContext';

const History = () => {
    const { t, lang } = useLang();
    return (
        <div data-testid="history-page">
            <PageHero
                eyebrow={t('history.hero_eyebrow')}
                title={t('history.hero_title')}
                sub={t('history.hero_sub')}
                image={ASSETS.offshore}
            />

            {/* Vertical Timeline */}
            <section className="bg-navy-deep py-24 md:py-32 grain-overlay">
                <div className="max-w-6xl mx-auto px-6 lg:px-10">
                    <div className="relative">
                        {/* Center line */}
                        <div className="absolute left-6 md:left-1/2 top-0 bottom-0 w-px bg-gold/30" />
                        <div className="space-y-16 md:space-y-24">
                            {MILESTONES.map((m, i) => {
                                const left = i % 2 === 0;
                                return (
                                    <ScrollReveal key={i} delay={0.05}>
                                        <div className={`relative grid grid-cols-1 md:grid-cols-2 gap-8 items-center ${left ? '' : 'md:[direction:rtl]'}`}>
                                            {/* Node */}
                                            <div className="absolute left-6 md:left-1/2 -translate-x-1/2 z-10">
                                                <div className="w-4 h-4 rounded-full bg-gold ring-4 ring-navy-deep" />
                                            </div>

                                            {/* Card */}
                                            <div className={`md:[direction:ltr] pl-16 md:pl-0 ${left ? 'md:pr-16 md:text-right' : 'md:pl-16'}`}>
                                                <div className={`inline-block ${left ? 'md:items-end md:text-right' : ''}`}>
                                                    <div className="metric-number text-3xl md:text-5xl mb-3">{m.year}</div>
                                                    <h3 className="font-display text-white text-xl md:text-2xl leading-snug">
                                                        {pick(m, 'title', lang)}
                                                    </h3>
                                                </div>
                                            </div>

                                            <div className={`md:[direction:ltr] pl-16 md:pl-0 ${left ? 'md:pl-16' : 'md:pr-16 md:text-right'}`}>
                                                <p className="text-white/70 leading-relaxed text-sm md:text-base max-w-md">
                                                    {pick(m, 'body', lang)}
                                                </p>
                                            </div>
                                        </div>
                                    </ScrollReveal>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </section>

            {/* Summary Table */}
            <section className="bg-cream py-24">
                <div className="max-w-6xl mx-auto px-6 lg:px-10">
                    <div className="eyebrow mb-5">{t('history.summary_eyebrow')}</div>
                    <h2 className="editorial-h2 text-navy text-3xl md:text-4xl mb-12">
                        {t('history.summary_h2')}
                    </h2>
                    <div className="overflow-x-auto">
                        <table className="editorial-table w-full" data-testid="milestones-table">
                            <thead>
                                <tr>
                                    <th>{t('history.col_year')}</th>
                                    <th>{t('history.col_milestone')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {MILESTONES.map((m) => (
                                    <tr key={m.year}>
                                        <td className="font-display text-navy w-40">{m.year}</td>
                                        <td className="text-ink/80">{pick(m, 'title', lang)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default History;
